import './controller.js';
//import '../programitem/studentprofilemodal';

import 'Sass/views/program-item-2022.scss';